import type { ApiClient } from '@travel/api-client';

import env from '@travel/env';
import type { AddFavoriteRequestBody, RemoveFavoriteRequestBody } from 'Favorite-Types';
import { ServiceType } from 'favoriteList/constants/favoriteLists';
import type { PlanResponse, ProviderResponse, RequestBody } from 'ProviderPlan-Types';

export const getProvidersListAPI = async (
  http: ApiClient,
  params: RequestBody,
): Promise<ProviderResponse> => {
  const endPoint =
    params.serviceType === ServiceType.DOMESTIC
      ? '/bookmark-domestic/provider-list'
      : '/bookmark-domestic/overseas-provider-list';

  return http.post(endPoint, {
    values: params,
    customParams: { isTravelAPI: true },
  });
};

export const getPlansListAPI = async (
  http: ApiClient,
  params: RequestBody,
): Promise<PlanResponse> => {
  const endPoint =
    params.serviceType === ServiceType.DOMESTIC
      ? '/bookmark-domestic/plan-list'
      : '/bookmark-domestic/overseas-plan-list';

  return http.post(endPoint, {
    values: params,
    customParams: { isTravelAPI: true },
  });
};

export const postAddFavoriteAPI = async (http: ApiClient, params: AddFavoriteRequestBody) => {
  return http.post('/bookmark-domestic/', {
    ignoreCommonErrorHandler: true,
    values: params,
    customParams: { isTravelAPI: true },
  });
};

export const postRemoveFavoriteAPI = async (http: ApiClient, params: RemoveFavoriteRequestBody) => {
  return http.delete('/bookmark-domestic/', {
    ignoreCommonErrorHandler: true,
    values: params,
    customParams: {
      isTravelAPI: true,
    },
  });
};

export const getFilterAPI = async (http: ApiClient, isPlanList: boolean) => {
  const isMockApiServer = env('UNIVERSAL_API_MOCK_SERVER') === 'true';
  const url = isMockApiServer
    ? `/share/featurefilter/${isPlanList ? 'Plan' : 'Hotel'}_List_Undated_Filter`
    : `https://trv.r10s.jp/share/featurefilter/${
        isPlanList ? 'Plan' : 'Hotel'
      }_List_Undated_Filter.json`;

  return http.get(url, {
    ignoreCommonErrorHandler: true,
    isThirdPartyApi: true,
    cache: true,
  });
};
